import React, { type ReactElement } from 'react'
import { Box, Flex } from '@chakra-ui/react'
const StickyNote = (props: any): ReactElement => {
  const { color, outlineColor = '#000000', outlineWidth = 2, ...rest } = props
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const primaryColor = `${color}.300`
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const shadowColor = `${color}.500`
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const darkColor = `${color}.400`

  return (
    <Box pos="relative" {...rest}>
      <Box
        as="svg"
        viewBox="0 0 300 300"
        version="1.1"
        sx={{
          path: {
            fillOpacity: 1
          },
          '#rect1': {
            fill: primaryColor,
            stroke: 'none',
            filter: 'drop-shadow(5px 5px 3px rgb(0 0 0 / 0.4))'
          },
          '#path4': {
            fill: shadowColor,
            fillOpacity: 1,
            stroke: 'none',
            filter: 'drop-shadow(5px 5px 3px rgb(0 0 0 / 0.4))'
          },
          '#path9': {
            fill: darkColor,
            fillOpacity: 1,
            stroke: 'none'
          },
          '#stickyNoteLayerOutline': {
            path: {
              fill: 'none',
              stroke: outlineColor,
              strokeWidth: outlineWidth,
              strokeLinecap: 'square',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }
          }
        }}
      >
        <g id="stickyNoteLayer" transform="translate(-3.27093,-2.059115)">
          <path
            id="rect1"
            d="M 7.2709296,6.0591147 H 293.26107 V 185.21183 c 0,7.87617 -3.78774,18.72094 -17.81751,18.81443 l -52.61391,0.48388 0.21673,65.09226 c 0.0323,9.69645 -10.21035,17.59957 -15.46817,17.59957 H 7.2709296 Z"
          />
          <path
            d="m 285.60467,201.31511 c -0.46395,0.29803 -0.94318,0.58441 -1.45898,0.83984 -0.58201,0.28823 -1.19667,0.54772 -1.84766,0.77539 -0.65099,0.22768 -1.33742,0.42356 -2.06055,0.58399 -0.72313,0.16043 -1.48283,0.28461 -2.28125,0.37109 -0.79842,0.0865 -1.63486,0.13479 -2.51172,0.14063 l -52.61523,0.48437 0.2168,65.0918 c 0.002,0.60603 -0.0364,1.2044 -0.11133,1.79492 -0.0749,0.59053 -0.18619,1.17405 -0.33008,1.7461 -0.28777,1.14408 -0.7055,2.24658 -1.22461,3.29882 -0.33698,0.68306 -0.77372,1.30534 -1.1875,1.94141 z"
            id="path4"
          />
          <path
            d="M 277.26092,6.0592477 V 185.21159 c 0,0.98453 -0.0585,2.01592 -0.18945,3.06641 -0.13098,1.05049 -0.33394,2.12072 -0.6211,3.18359 -0.28715,1.06288 -0.65839,2.11897 -1.12695,3.14063 -0.46855,1.02166 -1.03382,2.0087 -1.70898,2.93555 -0.33759,0.46342 -0.7037,0.91212 -1.09766,1.34179 -0.39396,0.42968 -0.81604,0.8393 -1.26953,1.22852 -0.45349,0.38922 -0.9389,0.75753 -1.45508,1.09961 -0.51617,0.34207 -1.06448,0.65904 -1.64648,0.94726 -0.58201,0.28823 -1.19667,0.54772 -1.84766,0.77539 -0.65099,0.22768 -1.33742,0.42356 -2.06055,0.58399 -0.72313,0.16043 -1.48283,0.28461 -2.28125,0.37109 -0.79842,0.0865 -1.63486,0.13479 -2.51172,0.14063 h 16 c 0.87686,-0.006 1.7133,-0.0541 2.51172,-0.14063 0.79842,-0.0865 1.55812,-0.21066 2.28125,-0.37109 0.72313,-0.16043 1.40956,-0.35631 2.06055,-0.58399 0.65099,-0.22767 1.26565,-0.48716 1.84766,-0.77539 0.582,-0.28822 1.13031,-0.60519 1.64648,-0.94726 0.51618,-0.34208 1.00159,-0.71039 1.45508,-1.09961 0.45349,-0.38922 0.87557,-0.79884 1.26953,-1.22852 0.39396,-0.42967 0.76007,-0.87837 1.09766,-1.34179 0.67516,-0.92685 1.24043,-1.91389 1.70898,-2.93555 0.46856,-1.02166 0.8398,-2.07775 1.12695,-3.14063 0.28716,-1.06287 0.49012,-2.1331 0.6211,-3.18359 0.13097,-1.05049 0.18945,-2.08188 0.18945,-3.06641 V 6.0592477 Z"
            id="path9"
          />
          <g
            id="stickyNoteLayerOutline"
            transform="translate(-123.20197,-56.147783)"
          >
            <path
              id="path10"
              d="M 130.4729,62.206898 H 416.46304 V 241.35961 c 0,7.87617 -3.78774,18.72094 -17.81751,18.81443 l -52.61391,0.48388 0.21673,65.09226 c 0.0323,9.69645 -10.21035,17.59957 -15.46817,17.59957 H 130.4729 Z"
            />
            <path
              d="m 408.80664,257.46289 c -0.46395,0.29803 -0.94318,0.58441 -1.45898,0.83984 -0.58201,0.28823 -1.19667,0.54772 -1.84766,0.77539 -0.65099,0.22768 -1.33742,0.42356 -2.06055,0.58399 -0.72313,0.16043 -1.48283,0.28461 -2.28125,0.37109 -0.79842,0.0865 -1.63486,0.13479 -2.51172,0.14063 l -52.61523,0.48437 0.2168,65.0918 c 0.002,0.60603 -0.0364,1.2044 -0.11133,1.79492 -0.0749,0.59053 -0.18619,1.17405 -0.33008,1.7461 -0.28777,1.14408 -0.7055,2.24658 -1.22461,3.29882 -0.33698,0.68306 -0.77372,1.30534 -1.1875,1.94141 z"
              id="path11"
            />
          </g>
        </g>
      </Box>
      <Flex
        className="sticky-note-content"
        flexDir="column"
        pos="absolute"
        top="0"
        bottom="0"
        right="0"
        left="0"
        justifyContent="center"
        p="5%"
      >
        {props.children}
      </Flex>
    </Box>
  )
}

export default StickyNote
